import React, { Component } from 'react';
import './pages/scss/pages.scss';
import './App.scss';

import { withRouter } from 'react-router';

import Condensed from './Theme/Condensed';
class App extends Component {
  render() {
    return (
      <div className='App'>
        <Condensed />
      </div>
    );
  }
}

export default withRouter(App);
